import { CSSProperties, DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react'
import clsx from 'clsx'

type ColProps = PropsWithChildren<{
  justifyContent?: CSSProperties['justifyContent']
  alignItems?: CSSProperties['alignItems']
  height?: CSSProperties['height']
  width?: CSSProperties['width']
}> &
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export const Col = ({
  children,
  className,
  justifyContent = 'center',
  alignItems = 'center',
  height,
  width,
  style,
  ...rest
}: ColProps) => {
  return (
    <div
      className={clsx(className)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent,
        alignItems,
        height,
        width,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  )
}
